import React from 'react'
import { Button } from 'react-bootstrap'

function UserPanelOffWaitlistCol({ user, disabled, onClick }) {
  if (user.offer_restrictions_applied) return <p>Under offer idle period</p>
  if (user.lib_restrictions_applied) return <p>Under Link-in-Bio idle period</p>

  return (
    <Button bsStyle="danger" disabled={disabled} style={{marginLeft: '20px'}} onClick={onClick}>
      Let Off Waitlist
    </Button>
  )
}

export default UserPanelOffWaitlistCol